export default "__VITE_ASSET__0kYkowAm__"